import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { queryClient } from '@/api/query-client';
import { router } from '@/router';
import { SessionProvider } from '@/components/auth/SessionProvider';
import { Toaster } from '@/components/ui';
import { useLanguageStore } from '@/i18n';

export function App() {
  const lang = useLanguageStore((state) => state.lang);

  return (
    <QueryClientProvider client={queryClient}>
      <SessionProvider>
        {/*
          `key={lang}`: dil değişince rota ağacı BAŞTAN kuruluyor.

          `t()` bir hook değil — çağrıldığı anda sözlükten okuyor ama hiçbir bileşen
          dile abone olmuyor. App'in abone olması tek başına yetmedi: RouterProvider
          eşleşen rotayı kendi durumundan çiziyor, üst bileşenin yeniden render olması
          alt ağacı tazelemiyordu. Canlıda doğrulandı — düğmeye basınca `html lang`
          değişiyor, metinler Türkçe kalıyordu.

          Bedeli: dil değişiminde sayfa durumu (açık akordiyon, form taslağı) sıfırlanır.
          Kalıcı çözüm `t()`'yi hook'a çevirip her çağrı yerini güncellemek.
        */}
        <RouterProvider key={lang} router={router} />
        <Toaster />
      </SessionProvider>
    </QueryClientProvider>
  );
}
